import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

const GraphUpIcon: React.FC<Props> = ({ className, ...props }) => (
  <svg
    className={className}
    width="36"
    height="40"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3756 13.4699H1V1.37823"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.8249L9.18782 5.15691L12.2583 7.42411L16.8639 4.02332"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GraphUpIcon;
